/**
 * The document's typed write operations, collected.
 *
 * Every one is a pure `(doc: AppDocument, …args) => T` function. **No module here imports React or
 * the Automerge React hooks** (ADR 0012 rule 3) — binding an operation to a document is
 * `use-document.ts`'s job, and keeping the two apart is what lets an operation be tested against a
 * real Automerge document with no renderer.
 *
 * This map is the surface `useDocumentOps()` binds. Adding an operation is a line here.
 */

import { archiveEntry, createEntry, updateEntry } from './entries'
import {
  linkEntryToPerson,
  setPersonLinks,
  unlinkEntryFromPerson,
} from './links'
import { archiveProject, createProject, updateProject } from './projects'
import { importEntities, recordSharedEntry, setTrust } from './document'
import { findOrCreateGenreTopics, findOrCreateTopic } from './topics'

export const operations = {
  createEntry,
  updateEntry,
  archiveEntry,
  linkEntryToPerson,
  unlinkEntryFromPerson,
  setPersonLinks,
  createProject,
  updateProject,
  archiveProject,
  findOrCreateTopic,
  findOrCreateGenreTopics,
  setTrust,
  recordSharedEntry,
  importEntities,
} as const

export type Operations = typeof operations

export type { EntryChange, EntryDraft, GenreScope } from './entries'
export type { ProjectChange, ProjectDraft } from './projects'
export type { DocumentContainer, EntryPatch, MetadataPatch } from './patch'
